import { any, bool, number } from "prop-types";
import React from "react";

import * as style from "./styles.module.scss";

const OnboardStateItem = ({
  isCompleted,
  isActive,
  children,
  index,
  currentIndex,
}) => (
  <div
    className={`${style.onboarding__step}
  ${isActive ? style.active : ""} ${
      isCompleted || currentIndex > index ? style.completed : ""
    }`}
  >
    <div className={`${style.onboarding__stepIcon} `}>
      <span className={isCompleted ? "d-none" : "d-block"}>{index + 1}</span>
      <i className={`icomoon-checkmark d-none ${isCompleted ? "d-block" : ""}`}>
        {" "}
      </i>
    </div>
    <div className={`${style.onboarding__stepName} d-none d-lg-block`}>
      {children}
    </div>
  </div>
);

OnboardStateItem.propTypes = {
  isCompleted: bool,
  isActive: bool,
  children: any,
  index: number,
  currentIndex: number,
};

export default OnboardStateItem;
